import { render, staticRenderFns } from "./ivr-test.vue?vue&type=template&id=5b8d6d52&scoped=true"
import script from "./ivr-test.vue?vue&type=script&lang=js"
export * from "./ivr-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d6d52",
  null
  
)

export default component.exports